module.exports = __webpack_public_path__ + "static/media/BF.af1b04cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/BF.svg
// module id = 202
// module chunks = 0